// src/components/InstitutionForm.form.js
import * as Yup from "yup";

export function initialValues(user, institution, isNew) {
  return {
    institutionName: isNew ? "" : institution?.institutionName || "",
    address: isNew ? "" : institution?.address || "",
    city: isNew ? "" : institution?.city || "",
    country: isNew ? "" : institution?.country || "",
    phone: isNew ? "" : institution?.phone || "",
    website: isNew ? "" : institution?.website || "",
    avatar: isNew ? "" : institution?.avatar || "",
    fileAvatar: null,
    firstname: isNew ? "" : institution?.firstname || "",
    lastname: isNew ? "" : institution?.lastname || "",
    email: isNew ? "" : institution?.email || "",
    password: "",
    role: "revi",
    partnerId: user.user._id,
    planEducaId: isNew ? "" : institution?.planEduca?._id || "",
    pacientesN: isNew ? 0 : institution?.pacientesN || 0,
    terapeutasN: isNew ? 0 : institution?.terapeutasN || 0,
  };
}

export function validationSchema(institution) {
  return Yup.object({
    institutionName: Yup.string().required("La institución es obligatoria"),
    address: Yup.string().required("La dirección es obligatoria"),
    city: Yup.string().required("La ciudad es obligatoria"),
    country: Yup.string().required("El país es obligatorio"),
    phone: Yup.string()
      .matches(/^[0-9]+$/, "Solo números")
      .min(9, "Mínimo 9 dígitos")
      .required("El teléfono es obligatorio"),
    website: Yup.string().url("Debe ser URL válida"),
    firstname: Yup.string().required("El nombre es obligatorio"),
    lastname: Yup.string().required("El apellido es obligatorio"),
    email: Yup.string()
      .email("Email inválido")
      .required("El email es obligatorio"),
    password: institution
      ? Yup.string()
      : Yup.string().required("La contraseña es obligatoria"),
    planEducaId: Yup.string().required("Selecciona un plan"),
  });
}
